import {
    getUserGroup,

} from "@/service/account/manageUser";
import {
    listUserInCourseAll,
    removeUserInCourseAll,
    removeUserInCourseAllWithLimit,
} from '@/service/mylib/list';
export default {
    computed: {
        selectedGroups() {
            return this.$vuetify.lang.t(
                "$vuetify.learnerManagement.learnerList.selectedGroups"
            );
        },

        headers() {
            return [
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.name"
                    ),
                    value: "fullName",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.username"
                    ),
                    value: "username",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.email"
                    ),
                    value: "email",
                    align: "start",
                    sortable: false,
                },
                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.group"
                    ),
                    value: "group",
                    align: 'center',
                    sortable: false,
                },
                // {
                //     text: this.$vuetify.lang.t(
                //         "$vuetify.learnerManagement.learnerList.username"
                //     ),
                //     value: "username",
                //     align: "start",
                //     sortable: false,
                // },

                {
                    text: this.$vuetify.lang.t(
                        "$vuetify.learnerManagement.learnerList.status"
                    ),
                    value: "active",
                    align: "start",
                    sortable: false,
                },
            ];
        },
    },
    data: function () {
        return {
            params: {},
            arrayGroup: [],
            userGroupSearch: [],
            selectedGroupsForMove: [],
            users: [],
            loading: false,
            confirm_dialog: false,
            confirm_dialog_status: false,
            imageReady: false,
            dialogStatus: false,
            dialogStatusActive: false,
            dialogMoveGroup: false,
            dataStatus1: [],
            dataStatus2: [],
            loadingDelete: false,
            dialogMultiDeleteSuccess: false,
            dialogMultiDeleteFail: false,

            page_student_delete: 1,
            pageCount_student_delete: 1,
        };
    },
    props: {
        isOpen: {
            type: Boolean,
        },
        isClose: {
            type: Function,
        },
        courseId: {
            type: String
        },
    },
    watch: {
        isOpen: async function (newValue) {
            if (newValue) {
                this.userGroupSearch = [];
                this.users = [];
                this.params = {
                    search: null,
                    sort: "created_at",
                    sortby: -1,
                    usergroup: null,
                    page: 1,
                    limit: 100,
                    active: "null",
                };
                this.paramsStudent = {
                    // search: null,
                    // sort: "created_at",
                    // sortby: -1,
                    usergroup: null,
                    page: 1,
                    limit: 10,
                    active: "null",
                    idcourse: this.courseId

                };
                console.log(newValue);
                this.getUserGroupList();
                // await getUserGroup()
            }
        },
    },

    methods: {
        closeDeleteDialog() {
            this.userGroupSearch = [];
            this.users = [];
            this.selectedGroupsForMove = [];
            this.closeDeleteUser();
        },
        async getUserGroupList() {
            let result = await getUserGroup(this.params);
            this.groupUsers = [];
            // let userGroupAllAtIndex=[]
            this.arrayGroup = [];
            this.arrayGroup.push({
                title: 'ไม่มีกลุ่ม',
                _id: '',
            });
            await result.forEach(async (group) => {
                // let arrayGroup = []
                group.child_User_Group.length === 0
                    ? await this.arrayGroup.push({
                        title: group.title,
                        _id: group._id,
                    })
                    : null;
                group.child_User_Group.forEach(async (child) => {
                    child.child_User_Group.length === 0
                        ? await this.arrayGroup.push({
                            title: group.title + " -> " + child.title,
                            _id: child._id,
                        })
                        : null;
                    child.child_User_Group.forEach(async (lastChild) => {
                        await this.arrayGroup.push({
                            title:
                                group.title + " -> " + child.title + " -> " + lastChild.title,
                            _id: lastChild._id,
                        });
                    });
                });
                // await userGroupAllAtIndex.push({arrayGroup})
            });
            console.log(this.arrayGroup);
            this.groupUsers = result;
            // this.filterGroupResult = result;
        },
        async applyFilter() {
            this.paramsStudent.usergroup = [];
            this.params.sort = null;
            this.params.sortby = null;
            if (this.status_toggle == 1) {
                this.params.active = true;
                this.params.page = this.page;
                this.paramsStudent.usergroup = await this.userGroupSearch;
                // console.log(this.paramsStudent.usergroup)
                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("if");
            } else if (this.status_toggle == 2) {
                this.params.active = false;
                this.params.page = this.page;
                this.paramsStudent.usergroup = await this.userGroupSearch;

                if (this.userGroupSearch.length != 0) {
                    await this.getUserList();
                } else {
                    this.users = [];
                }
                console.log("else if");
            } else {
                this.params.active = "null";
                this.params.page = this.page;
                this.paramsStudent.usergroupOld = [];
                this.paramsStudent.groupnull = false;

                if (this.userGroupSearch.length != 0) {
                    this.userGroupSearch.forEach(usr => {
                        if (usr._id != "") {
                            this.paramsStudent.usergroupOld.push(usr);
                            this.paramsStudent.usergroup.push(usr._id)
                        } else {
                            this.paramsStudent.groupnull = true;
                        }
                    });
                    await this.getUserList();
                } else {
                    this.users = [];
                }

                console.log("else");
            }
        },
        async getUserList() {
            this.loading = true;
            this.dataStatus1 = [];
            this.dataStatus2 = [];
            // localStorage.removeItem("editCourseID");
            // console.log(this.params);

            let result = await listUserInCourseAll(this.paramsStudent);
            this.users = [];
            this.pageCount_student_delete = Math.ceil(result.data.length / this.limit);
            this.pageCount_student_delete = result.maxPage;
            //   this.imageReady = false;
            await result.data.forEach(async (user) => {
                console.log(user)
                this.users.push({
                    id: user._id,
                    //   image: user.image,
                    fullName: user.firstName + " " + user.lastName,
                    email: user.email,
                    username: user.username,
                    active: user.active,
                    idMylib: user.mylib._id,
                    //user_groups: user.user_groups,
                    group: await this.showGroupList(user.user_groups),
                });
                if (user.active == false) {
                    this.dataStatus1.push({
                        id: user._id,
                    });
                } else {
                    this.dataStatus2.push({
                        id: user._id,
                    });
                }
            });
            // console.log("list user : ", this.users);
            //   this.imageReady = true;
            this.loading = false;
        },
        async showGroupList(userGroup) {
            let userGroupOutput = [];
            await userGroup.forEach(
                async (grouplist) =>
                    await this.arrayGroup.forEach(async (group) =>
                        group._id == grouplist._id
                            ? await userGroupOutput.push(group)
                            : null
                    )
            );
            return userGroupOutput;
        },
        async deleteMultiUser() {

            console.log(this.users)
            // let arrayidmylib = [];
            // for (let i in this.users) {
            //     this.loadingDelete = true;
            //     arrayidmylib.push({
            //         id: this.users[i].idMylib,
            //     });
            // }
            // console.log(arrayidmylib);
            // let result = await removeUserInCourseAll({
            //     arrayidmylib,
            // });
            let arrayIdUserGroup = [];
            for (let i in this.userGroupSearch) {
                this.loadingDelete = true;
                arrayIdUserGroup.push(
                    this.userGroupSearch[i]._id,
                );
            }
            let result = await removeUserInCourseAllWithLimit({
                idcourse: this.courseId,
                usergroup: arrayIdUserGroup,
            });

            console.log(result, status);
            if (result.length) {
                this.loadingDelete = false;
                this.dialogMultiDelete = false;
                this.confirm_dialog = false;
                this.dialogMultiDeleteSuccess = true;
                this.isClose();

                this.users = [];
                this.page_student_delete = 1;
                this.pageCount_student_delete - 1;

            }
            else {
                this.dialogMultiDeleteFail = true;
                this.dialogMultiDelete = false;
                this.loadingDelete = false;
                this.confirm_dialog = false;
                this.page_student_delete = 1;
                this.pageCount_student_delete - 1;
                this.users = [];
                await this.getUserList()
            }

        },

        async changePageStudent(page) {
            this.paramsStudent.page = page;
            this.users = [];
            await this.getUserList()
        },
    },
}
